
import { defineComponent, PropType, reactive } from 'vue'

// @components
import FileUploader from '@/modules/NewDispatcher/components/FileUploader/index.vue'

// @types
import { CourierIdentificationCard } from '@/new-services/types/couriers'

// @realisations
import { couriers } from '@/core/realisations/couriers.realisation'

// @composable
import useNotifications from '@/common/composable/useNotifications'

export default defineComponent({
    components: {
        FileUploader,
    },
    props: {
        identificationCards: {
            type: Array as PropType<CourierIdentificationCard[]>,
            default: () => []
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        loading: {
            type: Boolean,
            default: false,
        },
        courierId: {
            type: Number,
            default: null
        },
        isCanDelete: {
            type: Boolean,
            default: false,
        }
    },
    emits: ['files-uploaded'],
    setup(props, { emit }) {
        const notifications = useNotifications()

        const state = reactive({
            is_loading: false,
        })

        const onUploadFiles = async (files: File[]) => {
            try {
                state.is_loading = true

                const form_data = new FormData()
                form_data.append('type', '10')

                files.forEach((file) => {
                    form_data.append('files[]', file)
                })

                await couriers.uploadDocument(props.courierId, form_data)

                emit('files-uploaded')
                notifications.notify({ type: 'success', title: 'Фотографии удостоверения загружены' })
            } catch (error) {
                console.error(error)
                notifications.notifyError({ error, title: 'При загрузке фотографий удостоверения произошла ошибка' })
            } finally {
                state.is_loading = false
            }
        }

        return {
            state,
            onUploadFiles,
        }
    }
})
